import {Component, OnInit, ViewChild} from '@angular/core';
import {Job} from '../domain/job';
import {JobsService} from '../services/jobs.service';
import {ResourcesService} from '../services/resource.service';
import {Message, MessageService, SelectItem} from 'primeng/api';
import {Router} from '@angular/router';
import * as _ from 'underscore';
import {
  CSS_FAILED,
  CSS_OK,
  CSS_WARNING,
  DEVIATION_LIMIT,
  JOB_DEFINITION_PAGE,
  SharedDataService,
  STATUS_COMPLETE,
  STATUS_FAILED,
  STATUS_FORECAST,
  STATUS_HOLD,
  STATUS_MESSAGE_WAITING,
  STATUS_RUNNING
} from '../services/shared-data.service';
import {StorageService} from '../services/storage.service';
import {ArticleService} from '../services/article.service';
import {Article} from '../domain/article';
import {Table} from 'primeng/table';
import moment from 'moment-timezone';
import {AuthenticationGuard} from '../oauth/authentication.guard';
import { InsertJob } from '../domain/InsertJob';


@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.css'],
  standalone: false
})
export class JobsComponent implements OnInit {

  jobs: Job[];
  application: string;
  location: string;
  resource: string;
  applications: SelectItem[];
  locations: SelectItem[];
  resources: SelectItem[];
  statusOptions: SelectItem[];
  data: string[];
  msgs: Message[] = [];
  isFilterApp: boolean = true;
  selectedJob: Job;
  filters: string = 'Show Filters';

  numPages:number;

  counterLower: number;
  counterHigher: number;
  counter100: number;
  dataGraphic: number[];
  graphic: any;
  graphicHidden: boolean;
  bar: any;
  groupedData: any;
  dataBar: any;
  labels:string[];
  jobEndedOk:number[];
  jobNotOk:number[];
  jobRunning:number[];
  i: number;
  idToken;
  article: Article;
  displayHelp:any;
  cols: any[];

  selectedLocation: string ;
  selectedAppFullName: string[];
  selectedJobName: string;
  selectedDescription: string;
  selectedStatus: string [];
  selectedStartDate: Date;

  @ViewChild(('dt'), { static: true }) dtTable: Table;

  constructor(private readonly jobsService: JobsService, private readonly resourcesService: ResourcesService,
              private readonly router: Router, private readonly sharedDataService: SharedDataService,
              private readonly storageService: StorageService,
              private readonly authorizationService: AuthenticationGuard,
              private readonly articleService : ArticleService,
              private readonly messageService: MessageService) {
  }

  ngOnInit() {
    this.authorizationService.checkLogin();
    this.selectedAppFullName = null;
    this.selectedLocation = null;
    this.selectedJobName = null;
    this.selectedDescription = null;
    this.selectedStatus = null;
    this.selectedStartDate = null;
    this.graphicHidden = true;
    this.resources = [];
    this.labels = [];
    this.getResources();
    this.counter100 = 0;
    this.counterHigher=0;
    this.counterLower=0;
    this.jobEndedOk=[];
    this.jobNotOk= [];
    this.jobRunning= [];
    this.jobs= [];
    this.displayHelp = false;
    this.article = {text: "", title: ""};

    this.cols = [
      { field: 'appFullName', header: 'Application' , width: '14%'},
      { field: 'location', header: 'Location' , width: '10%'},
      { field: 'jobName', header: 'Name' , width: '10%'},
      { field: 'description', header: 'Description', width: '20%'},
      { field: 'status', header: 'Status' , width: '17%'},
      { field: 'startDate', header: 'Date' , width: '10%'},
      { field: 'startTime', header: 'Start Time' , width: '8%'},
      { field: 'endTime', header: 'End Time' , width: '8%'},
      { field: 'percentage', header: 'Run time/Avg time (Deviation %)' , width: '10%'}
    ];
  }


  onLoadTable (): void {

    this.statusOptions = [];
    //Select distinct of Status received
    this.jobs
      .filter(job => {
        return job.status != null;
      })
      .forEach(job => {
          //If status is not currently in the list, it is added (Distinct)
          if (_.findLastIndex(this.statusOptions, {label: job.status?.trim(), value: job.status?.trim()}) < 1) {
            this.statusOptions.push({label: job.status?.trim(), value: job.status?.trim()});
          }
        }
      );
    // Remove duplicates
    const uniqueStatus = Array.from(new Set(this.statusOptions.map(a => a.label)))
      .map(id => {
        return this.statusOptions.find(a => a.label === id)
      })
    this.statusOptions = uniqueStatus;



    if (this.sharedDataService.selectedAppFullName) {
      this.selectedAppFullName = this.sharedDataService.selectedAppFullName;
      this.listLocations();
      this.dtTable.filter(this.sharedDataService.selectedAppFullName, 'appFullName', 'equals');
    }
    if (this.sharedDataService.selectedLocation) {
      this.selectedLocation = this.sharedDataService.selectedLocation;
      this.listApplications();
      this.dtTable.filter(this.sharedDataService.selectedLocation, 'location', 'equals');
    }
    if (this.sharedDataService.selectedJobName ) {
      this.selectedJobName = this.sharedDataService.selectedJobName;
      this.dtTable.filter(this.sharedDataService.selectedJobName, 'jobName', 'contains');
    }
    if (this.sharedDataService.selectedDescription ) {
      this.selectedDescription = this.sharedDataService.selectedDescription;
      this.dtTable.filter(this.sharedDataService.selectedDescription, 'description', 'contains');
    }
    if (this.sharedDataService.selectedStatus) {
      this.selectedStatus = this.sharedDataService.selectedStatus;
      this.dtTable.filter(this.sharedDataService.selectedStatus, 'status', 'contains');
    }
    if (this.sharedDataService.selectedStartDate ) {
      this.selectedStartDate = this.sharedDataService.selectedStartDate;
      this.dtTable.filter(this.sharedDataService.selectedStartDate, 'startDate', 'equals');
    }
    if(this.sharedDataService.selectedAppFullName != null || this.sharedDataService.selectedLocation != null || this.sharedDataService.selectedJobName != null || this.sharedDataService.selectedDescription
      || this.sharedDataService.selectedStatus != null || this.sharedDataService.selectedStartDate != null){
      this.onFilterButtonClick();
    }
    this.sharedDataService.flushJobData();
  }

  onApplicationSelected() {
    if (this.resource != null && this.application !=null) {
      this.listLocations();
    }

  }

  onLocationSelected() {
    if (this.resource != null && this.location !=null) {
      this.listApplications();
    }
  }

  listApplications(): void {
    this.applications = [];
    this.jobs.forEach(job => {
        //If appFullName is not currently in the list, it is added (Distinct)
        if(_.findLastIndex(this.applications, {label: job.appFullName, value: job.appFullName}) < 1) {
          if (this.selectedLocation?.includes(job.location)
            || this.selectedLocation == null)
            this.applications.push({label: job.appFullName, value: job.appFullName});
        }
      }
    );
    // Remove duplicates
    const uniqueApplications = Array.from(new Set(this.applications.map(a => a.label)))
      .map(id => {
        return this.applications.find(a => a.label === id)
      })
    this.applications = uniqueApplications;
    this.applications = _.sortBy(this.applications, 'value');
  }

  listLocations(): void {
    this.locations = [];
    this.jobs.forEach(job => {
        //If location is not currently in the list, it is added (Distinct)
        if(_.findLastIndex(this.locations, {label: job.location, value: job.location}) < 1) {
          if (this.selectedAppFullName?.includes(job.appFullName)
            || this.selectedAppFullName == null)
            this.locations.push({label: job.location, value: job.location});
        }
      }
    );

    // Remove duplicates
    const uniqueLocations = Array.from(new Set(this.locations.map(a => a.label)))
      .map(id => {
        return this.locations.find(a => a.label === id)
      })
    this.locations = uniqueLocations;
    this.locations = _.sortBy(this.locations, 'value');
  }

  getJobs(resource: string): void {
    setTimeout(() => {
      this.jobsService.getJobs(resource)
        .subscribe(jobs => {
            // PONER A NULL
            for (let job of jobs ) {
              if (job.jobId == '630') {
                job.status ='f';
              }
            }
            this.jobs = jobs;
            this.buildGraphic();
            this.buildBar();
            this.graphicHidden = false;
            this.onLoadTable();

          }
        );
    });

  }

  getResources(): void {
    this.idToken= this.storageService.getItem('encodedAccessToken');
    setTimeout(() => {
      this.resourcesService.getResources(this.idToken)
        .subscribe(resources => {
            this.data = resources;
          },
          error => {console.error('Error retrieving resource systems' + error);
            this.resources.push({label: 'AS400-AAA', value: 'AS400-AAA'});
            // In case authError the AAA data is retrieved
          }, () => {
            for (let i = 0; i < this.data.length; i++) {
              this.resources.push({label: this.data[i], value: this.data[i]});

            }
            this.resources = _.sortBy(this.resources, 'label');
            // If resource is informed in sharedDataService, meaning the user clicked on Go Back on details section,
            // then, that resource is loaded. If not, default value is loaded
            if (this.sharedDataService.resource) {
              this.resource = this.sharedDataService.resource;

            }
            else {
              this.resource = this.resources[0]?.value;
            }
            this.getJobs(this.resource);
          });
    });

  }


  goDetails(selectedJob : Job): void {
    const iJob: InsertJob = new InsertJob(this.resource, selectedJob.jobId, this.selectedAppFullName, this.selectedLocation,
      this.selectedJobName, this.selectedDescription, this.selectedStatus, selectedJob.startDate);
    this.sharedDataService.insertJobData(iJob);
    this.router.navigate([JOB_DEFINITION_PAGE ]);
  }

  calculatePercentage(): void {
    this.jobs.forEach(job => {
        if(job.status !== STATUS_FORECAST) {
          if ((+job.runTime) - (+job.averageTime) < 0)
            this.counterLower = this.counterLower + 1;
          else if ((+job.runTime) - (+job.averageTime) > 0)
            this.counterHigher = this.counterHigher + 1;
          else
            this.counter100 = this.counter100 + 1;
        }
      }
    );
    this.dataGraphic = [this.counter100, this.counterHigher, this.counterLower];
  }

  buildGraphic(): void{
    this.listApplications();
    this.listLocations();
    this.calculatePercentage();
    this.graphic = {
      labels: ['Job in time', 'Job time exceeded','Job time below average'],
      datasets: [
        {
          data: this.dataGraphic,
          backgroundColor: [
            "#215B8F",
            "#DD5F26",
            "#EDC74F"
          ],
          hoverBackgroundColor: [
            "#215B8F",
            "#DD5F26",
            "#EDC74F"
          ]
        }]
    };

  }


  buildBar(): void{

    // Getting information splitted by application and status
    this.dataBar = _.map(this.jobs, function(currentObject) {
      return {appFullName: currentObject.appFullName, status: currentObject.status};
    });

    //Grouping the data at application level
    this.groupedData = _.groupBy(this.dataBar, 'appFullName');

    this.i = 0;
    this.jobEndedOk[this.i] = 0;
    this.jobNotOk[this.i] = 0;
    this.jobRunning[this.i] = 0;

    Object.entries(this.groupedData).forEach(
      ([key, value]) => {
        //Assigning the labels for the bar
        this.labels.push(key);
        this.jobEndedOk[this.i] = 0;
        this.jobNotOk[this.i] = 0;
        this.jobRunning[this.i] = 0;
        Object.entries(value).forEach(
          ([ , value2]) => {
            if (value2['status'] == STATUS_COMPLETE)
              this.jobEndedOk[this.i] = 0 ? 1 : this.jobEndedOk[this.i] + 1;
            if (value2['status'] == STATUS_FAILED)
              this.jobNotOk[this.i] = 0 ? 1 : this.jobNotOk[this.i] + 1;
            if (value2['status'] == STATUS_RUNNING)
              this.jobRunning[this.i] = 0 ? 1 : this.jobRunning[this.i] + 1;
          });
        this.i++;
      });

    // Creating the bar chart
    this.bar = {
      labels: this.labels,
      datasets: [
        {
          label: 'Jobs finished successfully',
          backgroundColor: "#215A8F",
          borderColor: "#215A8F",
          data: this.jobEndedOk
        },
        {
          label: 'Jobs in error',
          backgroundColor: "#DD5F26",
          borderColor: "#DD5F26",
          data: this.jobNotOk
        },
        {
          label: 'Jobs not finished',
          backgroundColor: "#EDC74F",
          borderColor: "#EDC74F",
          data: this.jobRunning
        }
      ]
    }
  }

  clearMessage() {
    this.msgs = [];
  }

  resetGraphics(): void{
    this.counter100 = 0;
    this.counterHigher=0;
    this.counterLower=0;
    this.jobEndedOk=[];
    this.jobNotOk= [];
    this.labels = [];
  }

  onFilterButtonClick() {
    if (this.isFilterApp) {
      this.isFilterApp = false;
      this.filters = 'Hide Filters';
    }else {
      this.isFilterApp = true;
      this.filters = 'Show Filters';
    }
  }

  onReloadTable(dt) {
    if (this.resource != null) {

      //Clear filters
      dt.reset();
      this.selectedAppFullName = null;
      this.selectedLocation = null;
      this.selectedJobName = null;
      this.selectedDescription = null;
      this.selectedStatus = null;
      this.selectedStartDate = null;

      //Graphics should be reset every time a resource is changed
      this.resetGraphics();
      this.graphicHidden = true;
      this.getJobs(this.resource);
    } else {
      this.messageService.add({key:'t1', severity: 'error', summary: 'Info Message', detail: 'No resource selected'});
    }
  }

  statusHandler(status:string): string{

    if (status.includes(STATUS_COMPLETE) || status.includes(STATUS_FORECAST))
      return CSS_OK;
    else if (status.includes(STATUS_FAILED) || status.includes(STATUS_MESSAGE_WAITING))
      return CSS_FAILED;
    else if (status.includes(STATUS_RUNNING))
      return CSS_WARNING;


  }

  statusIconHandler(status:string): string{
    if (status.includes(STATUS_COMPLETE))
      return "fa fa-check";
    else if (status.includes(STATUS_FAILED) || status.includes(STATUS_HOLD)
      || status.includes(STATUS_MESSAGE_WAITING) )
      return "fa fa-close";
    else if (status.includes(STATUS_RUNNING))
      return "fa fa-spinner";
    else if (status.includes(STATUS_FORECAST))
      return "fa fa-calendar";
    else
      return "fa fa-warning";
  }

  checkDeviation(deviation:number):boolean{
    return deviation > DEVIATION_LIMIT;
  }

  calculateDeviation(status: string, runtime: string, averageTime: string, percentage: number): string {
    if (status === STATUS_RUNNING || status === STATUS_FORECAST ) {
      return '--';
    } else {
      return runtime + ' / ' + averageTime + ' (' + percentage.toFixed(2) + ')';
    }

  }

  getArticle(reference: string): void{
    this.articleService.getArticle(reference).subscribe(
      data => this.article = data,
      () => {},
      () => this.displayHelp = true);
  }

  convertDate(event: any): String {
    let date = new Date(event);
    return moment(date).utc().format('YYYY-MM-DDTHH:mm:ss.000ZZ');
  }

}
